import { useNextRouter } from '@/data/Content/_NextRouter';
import { personMutatorKeyMatcher, useLogin, UserLogon } from '@/data/Content/Login';
import { useLocalization } from '@/data/Localization';
import {
	Box,
	Divider,
	IconButton,
	List,
	ListItem,
	Modal,
	Paper,
	Stack,
	Typography,
} from '@mui/material';
import { useSWRConfig } from 'swr';
import CloseIcon from '@mui/icons-material/Close';
import {
	ModalLoginContentSx,
	ModalLoginFrameSx,
	ModalLoginHeaderIconCloseFrameSx,
	ModalLoginHeaderIconCloseSx,
	ModalLoginRegisterContentSx,
	ModalLoginRegisterTextSx,
	ModalLoginRegisterTitleSx,
	ModalLoginTitleSx,
} from '@/components/content/Cart/parts/ModalLogin/styles/main';
import { SingleLoginForm } from '@/components/blocks/SingleLoginForm';
import { DpBaseButton } from '@/components/blocks/DpBaseButton';
import { useRecaptchaV3Setup } from '@/data/Content/Recaptcha';
import { useCurrentRoute } from 'integration/hooks/useCurrentRoute';

interface ModalLoginProps {
	onClose: () => void;
	onGoRegister: () => void;
}

export const ModalLoginFavorites: React.FC<ModalLoginProps> = ({ onClose, onGoRegister }) => {
	const router = useNextRouter();
	const RouteLocal = useLocalization('Routes');
	const { mutate } = useSWRConfig();
	const { loginSubmit } = useLogin();
	const { recaptchaEnabled, recaptchaExecute, recaptchaLoading } = useRecaptchaV3Setup();
	const currentRoute = useCurrentRoute();

	const handleLogin = async (props: UserLogon) => {
		let x_recaptchaToken: string | undefined = undefined;

		if (recaptchaEnabled) {
			x_recaptchaToken = await recaptchaExecute('login');
		}

		const resp = await loginSubmit({ ...props, x_recaptchaToken });

		if ('userId' in resp ?? {}) {
			if (router.query.flow === 'checkout') {
				await router.push(RouteLocal.CheckOut.route.t());
			} else {
				await router.push(currentRoute);
			}

			/*
			await router.push({
				pathname: RouteLocal.Cart.route.t(),
				query: {
					auth: 'login',
				},
			});
			*/
			await mutate(personMutatorKeyMatcher(''), undefined);
			onClose();
		}
	};

	return (
		<Modal open onClose={onClose}>
			<Paper sx={ModalLoginFrameSx}>
				<Stack direction="row" justifyContent="flex-end" width="100%">
					<IconButton onClick={onClose} sx={ModalLoginHeaderIconCloseFrameSx}>
						<CloseIcon sx={ModalLoginHeaderIconCloseSx} />
					</IconButton>
				</Stack>
				<Typography sx={ModalLoginTitleSx}>
					{'Crea una lista con tus productos favoritos'}
				</Typography>
				<Box sx={ModalLoginContentSx}>
					<Box>
						<Typography sx={{ ...ModalLoginRegisterTitleSx, mb: '4px' }}>
							{'INICIAR SESIÓN'}
						</Typography>
						<SingleLoginForm
							signInButtonLabel="Comprar con mi cuenta"
							forgotPasswordPosition="form"
							disabled={recaptchaLoading}
							onSubmit={handleLogin}
						/>
					</Box>
					<Divider orientation="vertical" />
					<Stack sx={ModalLoginRegisterContentSx}>
						<Box>
							<Typography sx={{ ...ModalLoginRegisterTitleSx, mb: '20px' }}>
								{'CREAR CUENTA'}
							</Typography>

							<Typography sx={ModalLoginRegisterTextSx}>
								{
									'Regístrate super rápido y recibe todos los beneficios de ser un usuario dportenis.'
								}
							</Typography>

							<List sx={{ ...ModalLoginRegisterTextSx, listStyleType: 'disc', pl: 2 }}>
								<ListItem sx={{ display: 'list-item', p: 0 }}>
									<Typography variant="body1">
										{'Promociones exclusivas y acumula puntos al comprar.'}
									</Typography>
								</ListItem>
								<ListItem sx={{ display: 'list-item', p: 0 }}>
									<Typography variant="body1">
										{'Ve el seguimiento a tu pedido en todo momento.'}
									</Typography>
								</ListItem>
								<ListItem sx={{ display: 'list-item', p: 0 }}>
									<Typography variant="body1">
										{'Realiza devolución o cambio, de manera rápida y fácil.'}
									</Typography>
								</ListItem>
							</List>
						</Box>
						<DpBaseButton
							sx={{
								mb: '19px',
								'&:hover': {
									backgroundColor: '#E8E8E8',
								},
							}}
							variant="secondary"
							onClick={onGoRegister}
						>
							{'Me quiero registrar'}
						</DpBaseButton>
					</Stack>
				</Box>
			</Paper>
		</Modal>
	);
};
